// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".read-more[data-v-4dff1597]{max-height:6.25rem}.read-more[data-v-4dff1597]:after{background:linear-gradient(0deg,#fff,hsla(0,0%,90.2%,0));content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}a[data-v-4dff1597]{text-decoration:underline}a[data-v-4dff1597]:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
